import { createReducer, on } from "@ngrx/store"
import { topProductsState } from "../homepage.state"
import * as homePageAction from '../action/fetch-topFetaureProduct.action';
import * as topProductPriceAction from '../action/fetch-topFeatureProductPrice.action';

const initialState: topProductsState = {
    products: [],
    loading: false,
    success: false,
    error: false,
}

export const topProductsReducer = createReducer(
    initialState,

    on(homePageAction.fetchTopProductsAction, (state) => ({
        ...state,
        loading: true,
        success: false,
        error: false
    })),
    on(homePageAction.fetchTopProductsActionFail, (state, { payload }) => ({
        ...state,
        payload: payload,
        loading: false,
        success: false,
        error: true
    })),
    on(homePageAction.fetchTopProductsActionSuccess, (state, { products }) => ({
        ...state,
        products: products,
        loading: false,
        success: true,
        error: false
    })),
    on(topProductPriceAction.fetchProductPriceAction, (state, { productCodes }) => ({
        ...state,
        products: state.products.map(product => (
            productCodes.includes(product.code)
                ? { ...product, priceLoading: true, priceError: false }
                : product
        )),
    })),
    on(topProductPriceAction.fetchProductPriceActionFail, (state, { error, productCodes }) => ({
        ...state,
        products: state.products.map(product => (
            productCodes && productCodes.includes(product.code)
                ? { ...product, priceLoading: false, priceError: true, error: error }
                : product
        )),
    })),
    on(topProductPriceAction.fetchProductPriceActionSuccess, (state, { priceItems }) => ({
        ...state,
        products: state.products.map(product => {
            const priceItem = priceItems.find((item: any) => item.code === product.code);
            if (priceItem) {
                return {
                    ...product,
                    ...priceItem,
                    priceLoading: false,
                    priceError: false,
                };
            }
            return product;
        }),
    }))
)